<template>
<div>
    <div v-if="loading" class="loading-spin">
        <SpinnerLoader :color="'#3c5d3d'" />
    </div>
	<div v-else :style="{ 'background' : data.impairedRegime ? '#ffffff' : '#f2f2f2', 'color' : data.impairedRegime ? '#000000' : '#333333'}" class="outer flex-col">
		<div v-if="lang" class="top-section flex-col">
			<div class="top-head-text flex-row">
				<h3 :style="{ 'color': data.impairedRegime ? '#000000' : '#568357' }">SHYN -</h3>
				<span v-if="lang === 'ru'">если честно...</span>
				<span v-if="lang === 'kk'">шынымен айтқанда...</span>
			</div>
			<span v-if="lang === 'ru'" class="top-body-text">Этот сайт – источник современной и достоверной информации о сексуальном и репродуктивном здоровье. Здесь вы получите честные и профессиональные ответы на вопросы о сексуальном и репродуктивном здоровье подростков и молодых людей.</span>
			<span v-if="lang === 'kk'" class="top-body-text">Бұл сайт – сексуалды-репродуктивті денсаулық туралы қазіргі заманғы әрі сенімді ақпарат көзі. Жасөспірімдер мен жастардың сексуалды-репродуктивті денсаулығы туралы сұрақтарыңызға шынайы және кәсіби жауап табасыз.</span>
			<a v-if="lang === 'ru'" @click="$router.push({ name: 'ask-question' })" :style="{ 'background' : data.impairedRegime ? '#000000' : '#568357', 'color' : data.impairedRegime ? '#ffffff' : '#FFECC7'}">Задать вопрос</a>
			<a v-if="lang === 'kk'" @click="$router.push({ name: 'ask-question' })" :style="{ 'background' : data.impairedRegime ? '#000000' : '#568357', 'color' : data.impairedRegime ? '#ffffff' : '#FFECC7'}">Сұрақ қою</a>
			<picture>
				<source type="image/webp" srcset="/media/home/Group-main.webp">
				<source type="image/png" srcset="/media/home/Group-main.png">
				<img v-if="data.impairedRegime" :style="{ 'filter' : 'grayscale(1)', '-webkit-filter' : 'grayscale(1)' }" class="top-img lazyload" data-src="/media/home/Group-main.png" alt="" >
				<img v-else class="top-img lazyload" data-src="/media/home/Group-main.png" alt="">
			</picture>
			
			<img v-if="data.impairedRegime" :style="{ 'filter' : 'grayscale(1)', '-webkit-filter' : 'grayscale(1)' }" class="top-img-mobile lazyload" data-src="/media/home/Group-main-mobile.png" alt="">
			<img v-else class="top-img-mobile lazyload" data-src="/media/home/Group-main-mobile.png" alt="">
		</div>
		<!-- <div class="male-section">
			<img src="/media/home/Group199.png" alt="">
			<h3>Мальчикам</h3>
			<div class="sep-line"></div>
			<p>Информация, которую необходимо знать</p>
			<div @click="$router.push({ name: 'rubric', query: { rubric: 'boys', sub: 'mybody' } })" class="go-link flex-row">
				<span>Перейти к рубрикам</span>
				<svg style="margin: 7px 30px 8px 10px; opacity: 0.2;" width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path d="M1 1L7 7L1 13" stroke="#568357" stroke-linecap="round" stroke-linejoin="round"/>
				</svg>	
				<svg style="margin: 7px 30px 8px 10px; opacity: 0.6;" width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path d="M1 1L7 7L1 13" stroke="#568357" stroke-linecap="round" stroke-linejoin="round"/>
				</svg>
				<svg style="margin: 7px 30px 8px 10px; opacity: 0.8;" width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path d="M1 1L7 7L1 13" stroke="#568357" stroke-linecap="round" stroke-linejoin="round"/>
				</svg>
				<svg style="margin: 7px 30px 8px 10px; opacity: 0.2;" width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path d="M1 1L7 7L1 13" stroke="#568357" stroke-linecap="round" stroke-linejoin="round"/>
				</svg>
			</div>
		</div>
		<div class="female-section">
			<img src="/media/home/Group200.png" alt="">
			<h3>Девочкам</h3>
			<div class="sep-line"></div>
			<p>Информация, которую необходимо знать</p>
			<div @click="$router.push({ name: 'rubric', query: { rubric: 'girls', sub: 'mybody' } })" class="go-link flex-row">
				<span>Перейти к рубрикам</span>
				<svg style="margin: 7px 30px 8px 10px; opacity: 0.2;" width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path d="M1 1L7 7L1 13" stroke="#568357" stroke-linecap="round" stroke-linejoin="round"/>
				</svg>	
				<svg style="margin: 7px 30px 8px 10px; opacity: 0.6;" width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path d="M1 1L7 7L1 13" stroke="#568357" stroke-linecap="round" stroke-linejoin="round"/>
				</svg>
				<svg style="margin: 7px 30px 8px 10px; opacity: 0.8;" width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path d="M1 1L7 7L1 13" stroke="#568357" stroke-linecap="round" stroke-linejoin="round"/>
				</svg>
				<svg style="margin: 7px 30px 8px 10px; opacity: 0.2;" width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path d="M1 1L7 7L1 13" stroke="#568357" stroke-linecap="round" stroke-linejoin="round"/>
				</svg>
			</div>
		</div> -->
		<div class="rubriks flex-col">
			<!-- <h3>Все рубрики</h3> -->
			<div class="single-rubrik flex-col">
				<div class="title">
					<p v-if="lang === 'ru'" :style="{ 'color' : data.impairedRegime ? '#000000' : '#4F4F4F' }">Мальчикам</p>
					<p v-if="lang === 'kk'" :style="{ 'color' : data.impairedRegime ? '#000000' : '#4F4F4F' }">Ұлдарға</p>
					<span v-if="lang === 'ru'" @click="$router.push({ name: 'rubric', query: { rubric: 'boys', sub: 'mybody' } })" :style="{ 'color': data.impairedRegime ? '#000000' : '#568357' }">Смотреть все</span>
					<span v-if="lang === 'kk'" @click="$router.push({ name: 'rubric', query: { rubric: 'boys', sub: 'mybody' } })" :style="{ 'color': data.impairedRegime ? '#000000' : '#568357' }">Барлығын көру</span>
				</div>
				<div :style="{ 'color': data.impairedRegime ? '#000000' : '#568357', 'filter' :  data.impairedRegime ? 'grayscale(1)' : 'grayscale(0)', '-webkit-filter' :  data.impairedRegime ? 'grayscale(1)' : 'grayscale(0)' }" class="list flex-row">
					<div @click="$router.push({ name: 'rubric', query: { rubric: 'boys', sub: 'mybody' } })" class="list-item">
						<div class="img-list-item" style="background: url(/media/home/boy1.png) no-repeat center center;background-color: rgba(86, 131, 87, 0.85);background-size: 30%;"></div>
						<span v-if="lang === 'ru'">Мое тело</span>
						<span v-if="lang === 'kk'">Менің тәнім</span>
					</div>
					<div @click="$router.push({ name: 'rubric', query: { rubric: 'boys', sub: 'transitional-age' } })" class="list-item">
						<div class="img-list-item" style="background: url(/media/home/boy2.png) no-repeat center center;background-color: #F0DCC4;background-size: 70%;"></div>
						<span v-if="lang === 'ru'">Переходный возраст</span>
						<span v-if="lang === 'kk'">Өтпелі кезең</span>
					</div>
					<div @click="$router.push({ name: 'rubric', query: { rubric: 'boys', sub: 'me-others' } })" class="list-item">
						<div class="img-list-item" style="background: url(/media/home/boy3.png) no-repeat center center;background-color: #AEBEB3;background-size: 70%;"></div>
						<span v-if="lang === 'ru'">Я и другие</span>
						<span v-if="lang === 'kk'">Мен және өзгелер</span>
					</div>
				</div>
			</div>
			<div class="single-rubrik flex-col">
				<div class="title">
					<p v-if="lang === 'ru'" :style="{ 'color' : data.impairedRegime ? '#000000' : '#4F4F4F' }">Девочкам</p>
					<p v-if="lang === 'kk'" :style="{ 'color' : data.impairedRegime ? '#000000' : '#4F4F4F' }">Қыздарға</p>
					<span v-if="lang === 'ru'" @click="$router.push({ name: 'rubric', query: { rubric: 'girls', sub: 'mybody' } })" :style="{ 'color': data.impairedRegime ? '#000000' : '#568357' }">Смотреть все</span>
					<span v-if="lang === 'kk'" @click="$router.push({ name: 'rubric', query: { rubric: 'girls', sub: 'mybody' } })" :style="{ 'color': data.impairedRegime ? '#000000' : '#568357' }">Барлығын көру</span>
				</div>
				<div :style="{ 'color': data.impairedRegime ? '#000000' : '#568357', 'filter' :  data.impairedRegime ? 'grayscale(1)' : 'grayscale(0)', '-webkit-filter' :  data.impairedRegime ? 'grayscale(1)' : 'grayscale(0)' }" class="list flex-row">
					<div @click="$router.push({ name: 'rubric', query: { rubric: 'girls', sub: 'mybody' } })" class="list-item">
						<div class="img-list-item" style="background: url(/media/home/girl1.png) no-repeat center center;background-color: #DEA89E; background-size: 30%;"></div>
						<span v-if="lang === 'ru'">Мое тело</span>
						<span v-if="lang === 'kk'">Менің тәнім</span>
					</div>
					<div @click="$router.push({ name: 'rubric', query: { rubric: 'girls', sub: 'transitional-age' } })" class="list-item">
						<div class="img-list-item" style="background: url(/media/home/girl2.png) no-repeat center center;background-color: #AEBEB3; background-size: 70%;"></div>
						<span v-if="lang === 'ru'">Переходный возраст</span>
						<span v-if="lang === 'kk'">Өтпелі кезең</span>
					</div>
					<div @click="$router.push({ name: 'rubric', query: { rubric: 'girls', sub: 'me-others' } })" class="list-item">
						<div class="img-list-item" style="background: url(/media/home/girl3.png) no-repeat center center;background-color: #EAD6D0; background-size: 70%;"></div>
						<span v-if="lang === 'ru'">Я и другие</span>
						<span v-if="lang === 'kk'">Мен және өзгелер</span>
					</div>
				</div>
			</div>
			<div class="single-rubrik flex-col">
				<div class="title">
					<p v-if="lang === 'ru'" :style="{ 'color' : data.impairedRegime ? '#000000' : '#4F4F4F' }">Родителям</p>
					<p v-if="lang === 'kk'" :style="{ 'color' : data.impairedRegime ? '#000000' : '#4F4F4F' }">Ата-аналарға</p>
					<span v-if="lang === 'ru'" @click="$router.push({ name: 'rubric', query: { rubric: 'parents', sub: 'important-for-parents' } })" :style="{ 'color': data.impairedRegime ? '#000000' : '#568357' }">Смотреть все</span>
					<span v-if="lang === 'kk'" @click="$router.push({ name: 'rubric', query: { rubric: 'parents', sub: 'important-for-parents' } })" :style="{ 'color': data.impairedRegime ? '#000000' : '#568357' }">Барлығын көру</span>
				</div>
				<div :style="{ 'color': data.impairedRegime ? '#000000' : '#568357', 'filter' :  data.impairedRegime ? 'grayscale(1)' : 'grayscale(0)', '-webkit-filter' :  data.impairedRegime ? 'grayscale(1)' : 'grayscale(0)' }" class="list flex-row">
					<div @click="$router.push({ name: 'rubric', query: { rubric: 'parents', sub: 'important-for-parents' } })" class="list-item">
						<div class="img-list-item" style="background: url(/media/home/parent3.png) no-repeat center center;background-color: rgba(232, 209, 204, 0.85); background-size: 100%;"></div>
						<span v-if="lang === 'ru'">Что важно знать родителям</span>
						<span v-if="lang === 'kk'">Ата-аналарға арналған маңызды</span>
					</div>
					<div @click="$router.push({ name: 'rubric', query: { rubric: 'parents', sub: 'about-complicated' } })" class="list-item">
						<div class="img-list-item" style="background: url(/media/home/parent2.png) no-repeat center center;background-color: #6E946D; background-size: 80%;"></div>
						<span v-if="lang === 'ru'">Просто о сложном</span>
						<span v-if="lang === 'kk'">Жай ғана күрделі туралы</span>
					</div>
					<div @click="$router.push({ name: 'rubric', query: { rubric: 'parents', sub: 'healthy-generation' } })" class="list-item">
						<div class="img-list-item" style="background: url(/media/home/parent4.png) no-repeat center center;background-color: #DEA89E; background-size: 70%;"></div>
						<span v-if="lang === 'ru'">Здоровое поколение</span>
						<span v-if="lang === 'kk'">Дені сау ұрпақ</span>
					</div>
				</div>
			</div>
			<div class="single-rubrik flex-col">
				<div class="title">
					<p v-if="lang === 'ru'" :style="{ 'color' : data.impairedRegime ? '#000000' : '#4F4F4F' }">Парням и девушкам</p>
					<p v-if="lang === 'kk'" :style="{ 'color' : data.impairedRegime ? '#000000' : '#4F4F4F' }">Бозбалалар мен бойжеткендерге арналған</p>
					<span v-if="lang === 'ru'" @click="$router.push({ name: 'rubric', query: { rubric: 'both', sub: 'about-body-health' } })" :style="{ 'color': data.impairedRegime ? '#000000' : '#568357' }">Смотреть все</span>
					<span v-if="lang === 'kk'" @click="$router.push({ name: 'rubric', query: { rubric: 'both', sub: 'about-body-health' } })" :style="{ 'color': data.impairedRegime ? '#000000' : '#568357' }">Барлығын көру</span>
				</div>
				<div :style="{ 'color': data.impairedRegime ? '#000000' : '#568357', 'filter' :  data.impairedRegime ? 'grayscale(1)' : 'grayscale(0)', '-webkit-filter' :  data.impairedRegime ? 'grayscale(1)' : 'grayscale(0)' }" class="list flex-row">
					<div @click="$router.push({ name: 'rubric', query: { rubric: 'both', sub: 'about-body-health' } })" class="list-item">
						<div class="img-list-item" style="background: url(/media/home/bg1.png) no-repeat center center;background-color: #AEBEB3; background-size: 60%;"></div>
						<span v-if="lang === 'ru'">О теле и его здоровье</span>
						<span v-if="lang === 'kk'">Тән және денсаулық туралы</span>
					</div>
					<div @click="$router.push({ name: 'rubric', query: { rubric: 'both', sub: 'contraception' } })" class="list-item">
						<div class="img-list-item" style="background: url(/media/home/bg2.png) no-repeat center center;background-color: #DEA89E; background-size: 75%;"></div>
						<span v-if="lang === 'ru'">Контрацепция</span>
						<span v-if="lang === 'kk'">Контрацепция</span>
					</div>
					<div @click="$router.push({ name: 'rubric', query: { rubric: 'both', sub: 'me-others' } })" class="list-item">
						<div class="img-list-item" style="background: url(/media/home/bg3.png) no-repeat center center;background-color: #F0DCC4; background-size: 100%;"></div>
						<span v-if="lang === 'ru'">Я и Другие</span>
						<span v-if="lang === 'kk'">Мен және өзгелер</span>
					</div>
				</div>
			</div>
		</div>
		<div class="rubriks-mobile flex-col">
			<h3 v-if="lang === 'ru'">Рубрики</h3>
			<h3 v-if="lang === 'kk'">Айдарлар</h3>
			<div class="rubs flex-row">
				<div @click="$router.push({ name: 'rubric', query: { rubric: 'boys', sub: 'mybody' } })" :style="{ 'color': data.impairedRegime ? '#000000' : '#568357', 'filter' :  data.impairedRegime ? 'grayscale(1)' : 'grayscale(0)', '-webkit-filter' :  data.impairedRegime ? 'grayscale(1)' : 'grayscale(0)' }" class="list-item flex-row">
					<div class="img-list-item" style="background: url(/media/home/boy6.png) no-repeat center center;background-color: rgba(86, 131, 87, 0.85);background-size: 22%;"></div>
					<span v-if="lang === 'ru'">Мальчикам</span>
					<span v-if="lang === 'kk'">Ұлдарға</span>
				</div>
				<div @click="$router.push({ name: 'rubric', query: { rubric: 'girls', sub: 'mybody' } })" :style="{ 'color': data.impairedRegime ? '#000000' : '#568357', 'filter' :  data.impairedRegime ? 'grayscale(1)' : 'grayscale(0)', '-webkit-filter' :  data.impairedRegime ? 'grayscale(1)' : 'grayscale(0)' }" class="list-item flex-row">
					<div class="img-list-item" style="background: url(/media/home/girl6.png) no-repeat center center;background-color: #F0DCC4;background-size: 30%;"></div>
					<span v-if="lang === 'ru'">Девочкам</span>
					<span v-if="lang === 'kk'">Қыздарға</span>
				</div>
				<div @click="$router.push({ name: 'rubric', query: { rubric: 'parents', sub: 'important-for-parents' } })" :style="{ 'color': data.impairedRegime ? '#000000' : '#568357', 'filter' :  data.impairedRegime ? 'grayscale(1)' : 'grayscale(0)', '-webkit-filter' :  data.impairedRegime ? 'grayscale(1)' : 'grayscale(0)' }" class="list-item flex-row">
					<div class="img-list-item" style="background: url(/media/home/parent3.png) no-repeat center center;background-color: #568357;background-size: 70%;"></div>
					<span v-if="lang === 'ru'">Родителям</span>
					<span v-if="lang === 'kk'">Ата-аналарға</span>
				</div>
				<div @click="$router.push({ name: 'rubric', query: { rubric: 'both', sub: 'about-body-health' } })" :style="{ 'color': data.impairedRegime ? '#000000' : '#568357', 'filter' :  data.impairedRegime ? 'grayscale(1)' : 'grayscale(0)', '-webkit-filter' :  data.impairedRegime ? 'grayscale(1)' : 'grayscale(0)' }" class="list-item flex-row">
					<div class="img-list-item" style="background: url(/media/home/bg1.png) no-repeat center center;background-color: #AEBEB3;background-size: 50%;"></div>
					<span v-if="lang === 'ru'">Парням и девушкам</span>
					<span v-if="lang === 'kk'">Бозбала мен бойжеткендерге арналған</span>
				</div>
			</div>
		</div>
		<div class="news">
			<div v-if="data.impairedRegime" :style="{ 'filter' : 'grayscale(1)', '-webkit-filter' : 'grayscale(1)' }" class="triangle"></div>
			<div  v-else class="triangle"></div>
			<div class="content flex-col">
				<h3 v-if="lang === 'ru'" :style="{ 'color': data.impairedRegime ? '#000000' : '#F6F4EB' }">Новости</h3>
				<h3 v-if="lang === 'kk'" :style="{ 'color': data.impairedRegime ? '#000000' : '#F6F4EB' }">Жаңалықтар</h3>
				<div v-if="dataNews" class="info flex-row">
					<div class="list flex-col">
						<div @click="$router.push({ name: 'single-news', params: { id: news.id } })" v-for="news in dataNews.filter( item  => dataNews.indexOf(item) < 4 )" :key="news.id" :style="{ 'box-shadow': data.impairedRegime ? '4px 10px 30px rgba(0, 0, 0, 0.2)' : '5px 20px 50px rgba(16, 112, 177, 0.2)' }" class="item flex-col">
							<div class="top flex-row">
								<span :style="{ 'color': data.impairedRegime ? '#000000' : '#EB5757' }" class="date">{{ formatDateTime( news.attributes.created ) }}</span>
								<!-- <svg style="margin-top: 4px;" width="24" height="18" viewBox="0 0 24 18" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path d="M1 9C1 9 5 1 12 1C19 1 23 9 23 9C23 9 19 17 12 17C5 17 1 9 1 9Z" stroke="#828282" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
								</svg>
								<span class="visible">233</span> -->
								<!-- <a :style="{ 'color': data.impairedRegime ? '#000000' : '#333333' }" class="link">{{ dataIncluded.find( item => item.id === news.relationships.uid.data.id ).attributes.name }}</a> -->
							</div>
							<div class="text">{{ news.attributes.title }}</div>
						</div>	
					</div>
					<div :style="{ 'filter' : data.impairedRegime ? 'grayscale(1)' : 'grayscale(0)', '-webkit-filter' : data.impairedRegime ? 'grayscale(1)' : 'grayscale(0)' }" class="news-list flex-row">
						<div @click="$router.push({ name: 'single-news', params: { id: news.id } })" v-for="news in dataNews.filter( item  => dataNews.indexOf(item) < 4 )" :key="news.id" :style="{ 'background-image' : news.relationships.field_cover_image.data ? 'url(' + 'https://mhsp.unfpa.org' + dataIncluded.find( item => item.type === 'file--file' && item.id === news.relationships.field_cover_image.data.id ).attributes.uri.url + ')' : 'white' }" class="item">
							<div class="text">
								<h5>{{ news.attributes.title }}</h5>
								<p>{{ news.attributes.field_short_description }}</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div v-if="surveyState === 3" :style="{ 'background' : data.impairedRegime ? '#ffffff' : '#F6F4EB '}" class="survey-end flex-col">
			<img v-if="data.impairedRegime" :style="{ 'filter' : 'grayscale(1)', '-webkit-filter' : 'grayscale(1)' }" data-src="/media/home/heart-handshake.png" alt="" class="lazyload">
			<img v-else data-src="/media/home/heart-handshake.png" alt="" class="lazyload">
			<h3 v-if="lang === 'ru'">Спасибо!</h3>
			<h3 v-if="lang === 'kk'">Рақмет!</h3>
			<p v-if="lang === 'ru'" :style="{ 'color': data.impairedRegime ? '#000000' : '#568357' }">Мы ценим каждый ответ</p>
			<p v-if="lang === 'kk'" :style="{ 'color': data.impairedRegime ? '#000000' : '#568357' }">Біз әр жауапты бағалаймыз</p>
		</div>
		<div v-else :style="{ 'background' : data.impairedRegime ? '#ffffff' : '#F6F4EB '}" class="survey">
			<h3 v-if="lang === 'ru'">Анонимный опрос</h3>
			<h3 v-if="lang === 'kk'">Анонимді сауалнама</h3>
			<p v-if="lang === 'ru'" class="q-num">Вопрос 1/10</p>
			<p v-if="lang === 'kk'" class="q-num">1/10 сұрақ</p>
			<p v-if="lang === 'ru'" :style="{ 'color': data.impairedRegime ? '#000000' : '#568357' }">Подвергались ли вы насилию?</p>
			<p v-if="lang === 'kk'" :style="{ 'color': data.impairedRegime ? '#000000' : '#568357' }">Зорлық-зомбылықты бастан өткердіңіз бе?</p>
			<div v-if="surveyState === 1" class="options flex-col">
				<div class="option flex-row">
					<input type="radio" id="one" value="Да" v-model="picked">
					<label v-if="lang === 'ru'" for="one">Да</label>
					<label v-if="lang === 'kk'" for="one">Иә</label>
				</div>
				<div class="option flex-row">
					<input type="radio" id="two" value="Нет" v-model="picked">
					<label v-if="lang === 'ru'" for="two">Нет</label>
					<label v-if="lang === 'kk'" for="two">Жоқ</label>
				</div>
				<div class="option flex-row">
					<input v-if="lang === 'ru'" type="radio" id="three" value="Затрудняюсь ответить" v-model="picked">
					<input v-if="lang === 'kk'" type="radio" id="three" value="Жауап беруге қиналамын" v-model="picked">
					<label v-if="lang === 'ru'" for="three">Затрудняюсь ответить</label>
					<label v-if="lang === 'kk'" for="three">Жауап беруге қиналамын</label>
				</div>
			</div>
			<div v-if="surveyState === 2" class="results flex-col">
				<div class="option flex-row">
					<span>25%</span>
					<label v-if="lang === 'ru'" for="one">Да</label>
					<label v-if="lang === 'kk'" for="one">Иә</label>
					<div :style="{ 'background': data.impairedRegime ? '#000000' : '#568357' }" class="line"></div>
				</div>
				<div class="option flex-row">
					<span>50%</span>
					<label v-if="lang === 'ru'" for="two">Нет</label>
					<label v-if="lang === 'kk'" for="two">Жоқ</label>
					<div :style="{ 'background': data.impairedRegime ? '#000000' : '#568357' }" class="line"></div>
				</div>
				<div class="option flex-row">
					<span>25%</span>
					<label v-if="lang === 'ru'" for="three">Затрудняюсь ответить</label>
					<label v-if="lang === 'kk'" for="three">Жауап беруге қиналамын</label>
					<div :style="{ 'background': data.impairedRegime ? '#000000' : '#568357' }" class="line"></div>
				</div>
			</div>
			<span v-if="lang === 'ru'" :style="{ 'color': data.impairedRegime ? '#000000' : '#568357' }" class="vote-total">20 голосов</span>
			<span v-if="lang === 'kk'" :style="{ 'color': data.impairedRegime ? '#000000' : '#568357' }" class="vote-total">20 дауыс</span>
			<div @click="(surveyState === 1) ? surveyState = 2 : surveyState = 3" :style="{ 'background' : data.impairedRegime ? '#000000' : '#568357', 'color' : data.impairedRegime ? '#ffffff' : '#FFECC7'}" class="next-btn flex-row">
				<span v-if="lang === 'ru'">Следующий вопрос</span>
				<span v-if="lang === 'kk'">Келесі сұрақ</span>
				<svg style="cursor: pointer; margin: 6px auto auto 12px" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path d="M8 0L6.59 1.41L12.17 7H0V9H12.17L6.59 14.59L8 16L16 8L8 0Z" fill="white"/>
				</svg>
			</div>
		</div>
		<div v-if="dataLocations" class="location flex-col">
			<h3 v-if="lang === 'ru'">Молодежные центры здоровья</h3>
			<h3 v-if="lang === 'kk'">Жастар Денсаулық Орталықтары</h3>
			<p v-if="lang === 'ru'" :style="{ 'color': data.impairedRegime ? '#000000' : '#4F4F4F' }">Все МЦЗ медицинской, медико-психологической, юридической и консультативной помощи по Республики Казахстан</p>
			<p v-if="lang === 'kk'" :style="{ 'color': data.impairedRegime ? '#000000' : '#4F4F4F' }">Қазақстан Республикасы бойынша Медициналық, медициналық-психологиялық, заң және консультативтік көмек көрсететін барлық ЖДО</p>
			<div v-if="dataLocations" class="local flex-row">
				<div :style="{ 'filter' : data.impairedRegime ? 'grayscale(1)' : 'grayscale(0)', '-webkit-filter' : data.impairedRegime ? 'grayscale(1)' : 'grayscale(0)' }" class="map">
					<gmap-map
						:center="center"
						:zoom="11"
						style="width: 100%; height: 100%"
						:options="{
							zoomControl: true,
							mapTypeControl: false,
							scaleControl: false,
							streetViewControl: false,
							rotateControl: false,
							fullscreenControl: true,
							disableDefaultUI: false
						}"	
					>
						<gmap-marker
						:key="index"
						v-for="(m, index) in markers"
						:position="m.position"
						:clickable="true"
						:draggable="true"
						@click="center=m.position"
						></gmap-marker>
					</gmap-map>
				</div>
				<div :style="{ 'background': data.impairedRegime ? 'rgba(0,0,0,0.6)' : '#F0DCC4' }" class="info flex-col">
					<div class="city flex-row">
						<svg style="margin-top: 4px;" width="18" height="24" viewBox="0 0 18 24" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M8.99961 0C4.31961 0 0.599609 3.72 0.599609 8.4C0.599609 14.64 8.99961 24 8.99961 24C8.99961 24 17.3996 14.64 17.3996 8.4C17.3996 3.72 13.6796 0 8.99961 0ZM8.99961 11.4C7.31961 11.4 5.99961 10.08 5.99961 8.4C5.99961 6.72 7.31961 5.4 8.99961 5.4C10.6796 5.4 11.9996 6.72 11.9996 8.4C11.9996 10.08 10.6796 11.4 8.99961 11.4Z" :fill="data.impairedRegime ? '#ffffff' : '#568357'"/>
						</svg>
						<span :style="{ 'color' : data.impairedRegime ? '#ffffff' : '#568357' }">{{ city }}</span>
					</div>
					<div v-for="location in dataLocations.filter( item => dataLocations.indexOf(item) < 3 )" :key="location.id" class="info-box flex-col">
						<h5>{{ location.attributes.field_name }}</h5>
						<div class="flex-row">
							<svg style="margin-top: 4px" width="10" height="14" viewBox="0 0 10 14" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path d="M5 1.65e-05C3.67727 -0.00337064 2.408 0.514851 1.46982 1.44122C0.53232 2.36815 0.00334545 3.62643 0 4.94065C0 7.67068 3.74996 14 5 14C6.25004 14 10 7.67068 10 4.94065C9.99659 3.62646 9.46761 2.36814 8.53018 1.44122C7.59212 0.514851 6.32276 -0.00336515 5 1.65e-05ZM5 6.48512C4.20397 6.48512 3.4864 6.00867 3.18182 5.27819C2.87727 4.54715 3.04545 3.70601 3.60852 3.14718C4.17103 2.58774 5.01761 2.42066 5.7534 2.72323C6.48863 3.02581 6.96817 3.73878 6.96817 4.52966C6.96817 5.60958 6.08692 6.4851 5.00003 6.4851L5 6.48512Z" fill="#4F4F4F"/>
							</svg>
							<span>{{ location.attributes.field_address_field_1 }}</span>
						</div>
						<div class="flex-row">
							<svg style="margin-top: 4px" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path d="M13.6709 10.4581L11.2316 9.08449C10.4185 8.62181 10.391 8.92544 9.53654 9.87971C9.32982 10.111 8.94394 10.7183 8.48915 10.6026C7.53824 10.3568 5.76045 8.89653 5.18163 8.23143C4.906 7.91334 3.7208 6.39518 3.70702 5.90359C3.67946 5.15174 5.25054 4.77582 4.74062 3.34441L3.6519 0.785236C2.63208 -1.67273 -0.220666 2.26002 0.0136171 4.09626C0.619997 8.62181 8.18597 15.9379 12.4031 13.5233C13.3402 12.9739 14.6081 11.0509 13.6709 10.4581Z" fill="#4F4F4F"/>
							</svg>
							<span>{{ location.attributes.field_telephone }}</span>
						</div>
						<div class="flex-row">
							<svg style="margin-top: 4px" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path d="M7 0C3.1402 0 0 3.1402 0 7C0 10.8598 3.1402 14 7 14C10.8598 14 14 10.8598 14 7C14 3.1402 10.8598 0 7 0Z" fill="#4F4F4F"/>
								<path d="M6.99987 1.40039C6.87107 1.40039 6.76654 1.50469 6.76654 1.63372V7.00039H3.26654C3.13774 7.00039 3.0332 7.10469 3.0332 7.23372C3.0332 7.36276 3.13774 7.46706 3.26654 7.46706H6.99987C7.12867 7.46706 7.2332 7.36276 7.2332 7.23372V1.63372C7.2332 1.50469 7.12867 1.40039 6.99987 1.40039Z" fill="white"/>
							</svg>
							<span>{{ location.attributes.field_hours_of_operation }}</span>
						</div>
					</div>
					<div @click="$router.push({ name: 'location' })" class="more-info flex-row">
						<span v-if="lang === 'ru'" :style="{ 'color': data.impairedRegime ? '#000000' : '#568357' }">Показать все</span>
						<span v-if="lang === 'kk'" :style="{ 'color': data.impairedRegime ? '#000000' : '#568357' }">Барлығын көрсету</span>
						<svg style="margin-top: 8px;" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M8 0L6.59 1.41L12.17 7H0V9H12.17L6.59 14.59L8 16L16 8L8 0Z" :fill="data.impairedRegime ? '#000000' : '#5E7361'"/>
						</svg>
					</div>
				</div>
			</div>
		</div>
		<div v-if="partnerImgs" class="partner flex-col">
			<div v-if="data.impairedRegime" :style="{ 'filter' : 'grayscale(1)', '-webkit-filter' : 'grayscale(1)' }">
				<h3 v-if="lang === 'ru'">Наши партнеры</h3>
				<h3 v-if="lang === 'kk'">Біздің серіктестер</h3>
				<vueper-slides
					class="no-shadow"
					:bullets="false"
					slide-image-inside
					:initSlide="1"
					:visible-slides="3"
					:gap="3"
					:slide-ratio="1 / 4"
					:dragging-distance="60">
					<vueper-slide v-for="item in partnerImgs" :key="item.id" :image="'https://mhsp.unfpa.org/' + item.attributes.uri.url" />
				</vueper-slides>
			</div>
			<div v-else>
				<h3 v-if="lang === 'ru'">Наши партнеры</h3>
				<h3 v-if="lang === 'kk'">Біздің серіктестер</h3>
				<vueper-slides
					class="no-shadow"
					:bullets="false"
					slide-image-inside
					:initSlide="1"
					:visible-slides="3"
					:gap="3"
					:slide-ratio="1 / 4"
					:dragging-distance="60">
					<vueper-slide v-for="item in partnerImgs" :key="item.id" :image="'https://mhsp.unfpa.org/' + item.attributes.uri.url" />
				</vueper-slides>
			</div>
		</div>
	</div>
</div>
</template>
<script>
import axios from 'axios'
import { func, api } from '../../variables.js'
import { VueperSlides, VueperSlide } from 'vueperslides'
import 'vueperslides/dist/vueperslides.css'

export default {
	props: [ 'data' ],
	components: { 
		VueperSlides, VueperSlide 
	},
	data(){
		return {
			surveyState: 1,
			picked: '',
			dataNews: '',
			dataIncluded: '',
			dataLocations: '',
			center: {lat: 43.23267859852702, lng: 76.90966259775811},
			markers: [],
			partnerImgs: [],
			city: '',
			lang: 'kk',
			loading: false
		}	
	},
	created(){
		if( localStorage.getItem('xyzCustomLang') ){
			this.lang = localStorage.getItem('xyzCustomLang')
		}
		this.getNews()
		this.getLocations()
		this.getPartners()
		
	},
	methods: {
		getNews(){
			this.loading = true
            axios.get( api + '/mhealth/jsonapi/node/srh_content/?filter[field_country.name]=KAZ&filter[langcode]=' + this.lang + '&sort=-created&page[offset]=0&page[limit]=10&filter[field_tags.name]=newsKZ&include=uid,uid.user_picture,field_cover_image' )
            .then((res) => {
                this.dataNews = res.data.data
				this.dataIncluded = res.data.included
				this.getLocations()
            })
            .catch((e) => {
				this.loading = false
                console.log('Error in loading news\n' + e)
            })
        },
		getLocations(){
            axios.get( api + '/mhealth/jsonapi/node/srh_service_provider/?filter[field_country.name]=KAZ&sort=created&page[offset]=0&&include=field_service_provided' )
            .then((res) => {
				let count = 0;
				this.dataLocations = res.data.data
				var lat = 0, lng = 0;
				this.city = 'Nur-Sultan'
				// console.log(this.dataLocations)
				this.dataLocations = this.dataLocations.filter( item => {
					if(item.attributes.field_city == this.city){
						return item
						// console.log(item.attributes.field_city)
					}
				})
				this.dataLocations.forEach( item => {
					count++;
					this.markers.push({
						position: {
							lat: Number(item.attributes.field_latitude),
							lng: Number(item.attributes.field_longitude)
						}
					})
					lat += Number(item.attributes.field_latitude)
					lng += Number(item.attributes.field_longitude)
				}) 
				this.center = {
					lat: Number((lat / count).toPrecision(6)),
					lng: Number((lng / count).toPrecision(6))
				}
				// this.center = {
				// 	lat: 51.1801,
				// 	lng: 71.44598
				// }
				this.getPartners()
            })
            .catch((e) => {
				this.loading = false
                console.log('Error in loading news\n' + e)
            })
		},
		getPartners(){
            axios.get( api + '/mhealth/jsonapi/node/srh_content/?filter[field_country.name]=KAZ&filter[title]=shyn partners&include=field_image.uid&filter[field_tags.name]=shyn_partners' )
            .then((res) => {
				this.partnerImgs = res.data.included
				this.partnerImgs = this.partnerImgs.filter( item => item.type === 'file--file' )
				this.loading = false
            })
            .catch((e) => {
				this.loading = false
                console.log('Error in loading news\n' + e)
            })
        },
		formatDateTime: func.formatDateTime
	}
}
</script>
<style scoped lang="scss">
*{
	transition: all 0.6s ease;
}
h3, span, p{
	cursor: default;
}
.outer{
	transition: none;
    .top-section{
		position: relative;
		padding: 60px 16% 10px 16%;
		h3, span, a{
			text-align: left;
			margin-top: 0;
			margin-bottom: 0;
			font-weight: 500;
			letter-spacing: 0.04em;
		}
		.top-head-text{
			h3{
				letter-spacing: 0.04em;
				font-size: 44px;
				line-height: 45px;
			}
			span{
				margin: 0px auto 0 18px;
				font-weight: 500;
				font-size: 34px;
				line-height: 45px;
				letter-spacing: 0.04em;
			}
		}
		.top-body-text{
			max-width: 446px;
			margin-top: 30px;
			font-weight: 500;
			font-size: 20px;
			line-height: 25px;
			letter-spacing: 0.03em;
			opacity: 0.6;
		}
		a{
			cursor: pointer;
			width: 220px;
			padding: 15px;
			text-decoration: none;
			margin-top: 50px;
			box-shadow: 5px 20px 50px rgba(94, 115, 97, 0.3);
			border-radius: 10px;
			font-size: 16px;
			line-height: 26px;
			text-align: center;
		}	
		.top-img{
			position: absolute;
			top: 60px;
			right: 2%;	
			z-index: 99;
			transform: scale(0.25) translateX(150%) translateY(-160%);
		}
		.top-img-mobile{
			display: none;
		}
    }
	.male-section{
		position: relative;
		height: 209px;
		margin-top: 190px;
		background: #568357;
		padding: 53px 0 30px 24%;
		overflow: hidden;
		img{
			position: absolute;
			left: 10%;
			top: 14px;
			height: 100%;
		}
		h3, p{
			text-align: left;
			letter-spacing: 0.05em;
			color: #F6F4EB;
		}
		h3{
			margin-top: 0;
			margin-bottom: 0;
			font-weight: bold;
			font-size: 26px;
			line-height: 30px;
		}
		.sep-line{
			margin: 20px 0;
			height: 1px;
			background: #F6F4EB;
		}
		p{
			font-weight: 500;
			font-size: 20px;
			line-height: 26px;
			opacity: 0.9;
		}
		.go-link{
			opacity: 0;
			cursor: pointer;
			margin-top: 58px;
			height: 26px;
			padding: 15px 30px;
			background: #F6F4EB;
			box-shadow: 5px 20px 50px rgba(94, 115, 97, 0.5);
			border-top-left-radius: 10px;
			border-bottom-left-radius: 10px;
			-webkit-transition: opacity 0.4s ease-in-out;
			-moz-transition: opacity 0.4s ease-in-out;
			-ms-transition: opacity 0.4s ease-in-out;
			-o-transition: opacity 0.4s ease-in-out;
			transition: opacity 0.4s ease-in-out;
			span{
				cursor: pointer;
				font-weight: 500;
				font-size: 16px;
				line-height: 26px;
				text-align: center;
				letter-spacing: 0.04em;
				color: #568357;
			}
		}
	}
	.male-section:hover {
		.go-link{
			opacity: 1;
			-webkit-transition: opacity 0.4s ease-in-out;
			-moz-transition: opacity 0.4s ease-in-out;
			-ms-transition: opacity 0.4s ease-in-out;
			-o-transition: opacity 0.4s ease-in-out;
			transition: opacity 0.4s ease-in-out;
		}
	}
	.female-section{
		position: relative;
		height: 209px;
		background: #F0E4D5;
		padding: 53px 0 30px 24%;
		overflow: hidden;
		filter: drop-shadow(0px 0px 34px rgba(35, 31, 32, 0.2));
		img{
			position: absolute;
			left: calc(7%);
			top: 14px;
			height: 100%;
		}
		h3, p{
			text-align: left;
			letter-spacing: 0.05em;
			color: #568357;
		}
		h3{
			margin-top: 0;
			margin-bottom: 0;
			font-weight: bold;
			font-size: 26px;
			line-height: 30px;
		}
		.sep-line{
			margin: 20px 0;
			height: 1px;
			background: #568357;
		}
		p{
			font-weight: 500;
			font-size: 20px;
			line-height: 26px;
			opacity: 0.9;
		}
		.go-link{
			opacity: 0;
			cursor: pointer;
			margin-top: 58px;
			height: 26px;
			padding: 15px 30px;
			background: #F6F4EB;
			box-shadow: 5px 20px 50px rgba(94, 115, 97, 0.5);
			border-top-left-radius: 10px;
			border-bottom-left-radius: 10px;
			-webkit-transition: opacity 0.4s ease-in-out;
			-moz-transition: opacity 0.4s ease-in-out;
			-ms-transition: opacity 0.4s ease-in-out;
			-o-transition: opacity 0.4s ease-in-out;
			transition: opacity 0.4s ease-in-out;
			span{
				cursor: pointer;
				font-weight: 500;
				font-size: 16px;
				line-height: 26px;
				text-align: center;
				letter-spacing: 0.04em;
				color: #568357;
			}
		}
	}
	.female-section:hover {
		.go-link{
			opacity: 1;
			-webkit-transition: opacity 0.4s ease-in-out;
			-moz-transition: opacity 0.4s ease-in-out;
			-ms-transition: opacity 0.4s ease-in-out;
			-o-transition: opacity 0.4s ease-in-out;
			transition: opacity 0.4s ease-in-out;
		}
	}
	.rubriks{
		margin-top: 110px;
		padding: 60px 176px;
		h3{
			margin: 0;
			text-align: left;
			font-weight: bold;
			font-size: 44px;
			line-height: 45px;
			letter-spacing: 0.04em;
		}
		.single-rubrik{
			margin: 40px 0 20px 0;
			position: relative;
			.title{
				p{
					margin: 0;
					text-align: left;
					font-weight: 500;
					font-size: 34px;
					line-height: 45px;
					letter-spacing: 0.04em;
				}
				span{
					cursor: pointer;
					position: absolute;
					right: 36px;
					top: 0;
					font-weight: 500;
					font-size: 24px;
					line-height: 45px;
					letter-spacing: 0.04em;
				}
			}
			.list{
				flex-wrap: wrap;
				.list-item{
					cursor: pointer;
					margin-top: 23px;
					width: calc(33% - 122px - 24px);
					height: 168px;
					margin-right: 36px; 		
					border-radius: 10px;
					padding: 7px 61px 45px 61px;
					position: relative;
					background: #F6F4EB;
					.img-list-item{
						margin: 0 auto;
						border-radius: 50%;
						height: 168px;
						width: 168px;
					}
					span{
						text-align: left;
						text-overflow: ellipsis;
						overflow: hidden; 
						width: calc(100% - 28px);
						white-space: nowrap;
						position: absolute;
						bottom: 14px;
						left: 10px;
						font-weight: bold;
						font-size: 24px;
						line-height: 26px;
					}
				}
				.list-item:nth-of-type(3n){
					margin-right: 0;
				}
				.list-item:hover{
					box-shadow: 5px 20px 50px rgba(94, 115, 97, 0.35);
				}
			}
		}
	}
	.rubriks-mobile{
		display: none;
	}
	.news{
		height: 674px;
		overflow: hidden;
		position: relative;
		margin-bottom: 100px;
		.triangle {
			position: absolute;
			top: 0;
			width: calc(100% + 200px);
			height: 674px;
			background: linear-gradient(to right bottom, #568357 0%, #568357 50%, #F2F2F2 50%, #F2F2F2 100%);
			z-index: 1;
		}
		.content{
			padding: 74px 0px 155px 16%;
			z-index: -1;
			h3{
				text-align: left;
				margin: 0;
				font-weight: bold;
				font-size: 44px;
				line-height: 45px;
				letter-spacing: 0.04em;
				z-index: 98;
			}
			.info{
				margin-top: 40px;
				width: 300%;
				.list{
					.item{
						z-index: 98;
						cursor: pointer;
						margin-bottom: 30px;
						height: 72px;
						width: 380px;
						background: #FFFFFF;
						border-radius: 10px;
						padding: 10px 23px 15px 15px;
						.top{
							position: relative;
							.date{
								cursor: pointer;
								margin-right: 24px;
								font-weight: 500;
								font-size: 16px;
								line-height: 26px;
								letter-spacing: 0.04em;
							}
							.visible{
								cursor: pointer;
								margin-left: 5px;
								font-weight: 500;
								font-size: 14px;
								line-height: 26px;
								letter-spacing: 0.04em;
								color: #828282;
							}
							.link{
								cursor: pointer;
								text-decoration: none;
								position: absolute;
								right: 0;
								font-weight: 500;
								font-size: 16px;
								line-height: 30px;
								letter-spacing: 0.05em;
							}
						}
						.text{
							text-align: left;
							margin-top: 4px;
							font-weight: 500;
							font-size: 18px;
							line-height: 20px;
							letter-spacing: 0.04em;
							display: -webkit-box;
							-webkit-line-clamp: 2;
							-webkit-box-orient: vertical;
							overflow: hidden;
							text-overflow: ellipsis;
						}
					}
				}
				.news-list{
					z-index: 98;
					margin-left: 8px;
					overflow-x: hidden;
					.item{
						cursor: pointer;
						position: relative;
						margin-left: 30px;
						height: 460px;
						width: 485px;
						background: center no-repeat;
						background-size: cover;
						// box-shadow: 5px 20px 50px rgba(0, 0, 0, 0.2);
						border-radius: 10px;
						.text{
							width: 385px;
							position: absolute;
							bottom: 0;
							height: 105px;
							background: rgba(86, 105, 126, 0.7);
							backdrop-filter: blur(14px);
							border-radius: 0px 0px 10px 10px;
							padding: 20px 50px;
							h5, p{
								text-align: left;
								margin: 0;
							}
							h5{
								height: 30px;
								text-overflow: ellipsis;
								overflow: hidden; 
								white-space: nowrap;
								font-weight: bold;
								font-size: 20px;
								line-height: 30px;
								letter-spacing: 0.05em;
								color: #FFFFFF;
							}
							p{
								// height: 65px;
								cursor: pointer;
								margin-top: 10px;
								font-weight: 500;
								font-size: 16px;
								line-height: 22px;
								letter-spacing: 0.05em;
								color: #FFFFFF;
								display: -webkit-box;
								-webkit-line-clamp: 2;
								-webkit-box-orient: vertical;
								overflow: hidden;
								text-overflow: ellipsis;
							}
						}
					}
				}
			}
		}
	}
	.survey{
		height: 403px;
		padding: 20px 16%;
		position: relative;
		h3, label, p, span{
			margin: 0;
			text-align: left;
		}
		h3{
			font-weight: bold;
			font-size: 44px;
			line-height: 49px;
			letter-spacing: 0.04em;
		}
		.q-num{
			margin-top: 40px;
			font-weight: 500;
			font-size: 16px;
			line-height: 30px;
			letter-spacing: 0.05em;
		}
		p{
			margin-top: 10px;
			font-weight: bold;
			font-size: 26px;
			line-height: 30px;
			letter-spacing: 0.05em;
		}
		.options{
			.option{
				margin-top: 15px;
				label{
					cursor: pointer;
					margin-left: 15px;
					font-weight: 500;
					font-size: 18px;
					line-height: 26px;
					letter-spacing: 0.04em;
				}
				input[type="radio"] {
					cursor: pointer;
					margin: 0;
					height: 24px;
					width: 24px;	
				}

			}
		}
		.results{
			.option{
				margin-top: 15px;
				position: relative;
				span{
					font-weight: 500;
					font-size: 18px;
					line-height: 26px;
					letter-spacing: 0.04em;
				}
				label{
					margin-left: 15px;
					font-weight: 500;
					font-size: 18px;
					line-height: 26px;
					letter-spacing: 0.04em;
				}
				.line{
					position: absolute;
					bottom: -5px;
					left: 50px;
					height: 5px;
					width: 100px;
					border-radius: 10px
				}
			}
		}
		.vote-total{
			position: absolute;
			bottom: 34px;
			left: 16%;
			font-weight: 500;
			font-size: 16px;
			line-height: 30px;
			letter-spacing: 0.04em;
			opacity: 0.8;
		}
		.next-btn {
			cursor: pointer;
			position: absolute;
			height: 26px;
			width: 192px;
			bottom: 20px;
			right: 16%;
			background: #568357;
			box-shadow: 5px 10px 20px rgba(53, 110, 173, 0.2);
			border-radius: 10px; 
			padding: 15px 94px;
			span{
				cursor: pointer;
				font-weight: 500;
				font-size: 16px;
				line-height: 26px;
				letter-spacing: 0.04em;
				color: #FFFFFF;
			}
		}
	}
	.survey-end{
		height: 218px;
		background: #F6F4EB;
		padding: 65px 0 120px 0;
		position: relative;
		img, h3, p{
			margin: 0 auto;
		}
		h3{
			margin-top: 28px;
			font-weight: bold;
			font-size: 44px;
			line-height: 49px;
			letter-spacing: 0.04em;
		}
		p{
			margin-top: 20px;
			font-weight: 500;
			font-size: 26px;
			line-height: 30px;
			letter-spacing: 0.05em;
		}
		img{
			width: 10%;
		}
	}
	.location{
		padding: 100px 16% 0 16%;
		h3, p{
			margin: 0;
			text-align: left;
		}
		h3{
			font-weight: bold;
			font-size: 44px;
			line-height: 45px;
			letter-spacing: 0.04em;
		}
		p{
			margin-top: 16px;
			font-weight: 300;
			font-size: 24px;
			line-height: 35px;
			letter-spacing: 0.04em;
		}
		.local{
			width: 100%;
			height: 490px;
			margin-top: 30px;
			border-radius: 10px;
			.map{
				width: calc(100% - 325px);
				img{
					object-fit: contain;
				}
			}
			.info{
				position: relative;
				padding: 10px 20px 48px 41px;
				width: 265px;
				overflow: hidden;
				.city{
					margin-bottom: 0px;
					span{
						margin-left: 14px;
						font-weight: 500;
						font-size: 16px;
						line-height: 30px;
						letter-spacing: 0.04em;
						color: #568357;
						opacity: 0.8;
					}
				}
				.info-box{
					margin-top: 10px;
					padding: 12px 10px;
					width: 245px;
					background: #FFFFFF;
					box-shadow: 0px 8px 12px rgba(43, 42, 41, 0.05), 0px 10px 26px rgba(43, 42, 41, 0.05);
					border-radius: 10px;
					h5, span{
						margin: 0;
					}
					h5{
						text-align: left;
						text-overflow: ellipsis;
						white-space: nowrap;
						overflow: hidden; 
						width: calc(100%);
						cursor: default;
						margin-bottom: 0px;
						font-weight: 500;
						font-size: 16px;
						line-height: 22px;
						letter-spacing: -0.44px;
						color: #000000;
					}
					div{
						margin-top: 5px;
						span{
							margin-left: 14px;
							font-weight: 300;
							font-size: 14px;
							line-height: 22px;
							letter-spacing: -0.44px;
							color: #333333;
						}
					}
				}
				.more-info{
					cursor: pointer;
					position: absolute;
					bottom: 10px;
					left: 41px;
					span{
						cursor: pointer;
						margin-right: 26px;
						font-weight: 500;
						font-size: 14px;
						line-height: 30px;
						letter-spacing: 0.05em;
						color: #5E7361;
					}
				}
			}
		}
	}
	.partner{
		padding: 30px 12%;
		height: 300px;
		h3{
			text-align: left;
			margin: 0;
			margin-left: 5%;
			font-weight: bold;
			font-size: 44px;
			line-height: 49px;
			letter-spacing: 0.04em;
			color: #333333;
		}
		.no-shadow{
			// margin-top: 46px;
			position: relative;
			width: 100%;
			height: 221px !important;
		}
	}
}
@media only screen and (max-width: 1330px){
	.outer{
		.top-section{
			padding: 60px 12% 10px 12%;
			.top-head-text{
				h3{
					font-size: 38px;
					line-height: 38px;
				}
				span{
					font-size: 28px;
					line-height: 38px;
				}
			}
			.top-body-text{
				font-size: 18px;
				line-height: 24px;
			}
			a{
				margin-top: 40px;
			}	
			.top-img{
				transform: scale(0.18) translateX(230%) translateY(-240%);
			}
		}
		.rubriks{
			padding: 60px 16%;
			margin-top: 20px;
			.single-rubrik{
				margin: 30px 0 10px 0;
				.title{
					p{
						font-size: 30px;
						line-height: 30px;
					}
					span{

						font-size: 22px;
						line-height: 30px;

					}
				}
				.list{
					.list-item{
						width: calc(33% - 42px - 16px);
						height: 148px;
						margin-right: 24px; 		
						padding: 7px 21px 45px 21px;
						.img-list-item{
							
							height: 148px;
							width: 148px;
						}
						span{
							width: calc(100% - 20px);
							bottom: 10px;
							font-size: 20px;
							line-height: 26px;
						}
					}
				}
			}
		}
		.news{
			margin-bottom: 50px;
			.content{
				padding: 74px 0px 155px 10%;
				h3{
					font-size: 38px;
					line-height: 38px;
				}
				.info{
					overflow: hidden;
					.list{
						.item{
							width: 320px;
							margin-bottom: 20px;
						}
					}
					.news-list{
						.item{
							margin-left: 20px;
							height: 390px;
							width: 390px;
							.text{
								width: 350px;
								padding: 12px 20px;
							}
						}
					}
				}
			}
		}
		.location{
			padding: 100px 10% 0 10%;
			h3{
				font-size: 38px;
				line-height: 38px;
			}
			p{
				font-size: 22px;
				line-height: 28px;
			}
			.local{
				.info{
					padding: 8px 30px 48px 30px;
				}
			}
		}
		.partner{
			padding: 30px 10%;
			height: 240px;
			h3{
				margin-left: 0;
				font-size: 38px;
				line-height: 38px;
			}
		}
	}
}
@media only screen and (max-width: 1024px){
	.outer{
		.top-section{
			padding: 40px 12% 10px 12%;
			.top-head-text{
				h3{
					font-size: 32px;
					line-height: 38px;
				}
				span{
					margin-top: 2px;
					font-size: 26px;
					line-height: 28px;
				}
			}
			.top-body-text{
				max-width: 100%;
				margin-top: 230px;
				font-size: 18px;
				line-height: 24px;
			}
			a{
				margin-top: 20px;
			}	
			.top-img{
				display: none;
			}
			.top-img-mobile{
				display: block;
				position: absolute;
				top: 60px;
				right: 2%;	
				z-index: 99;
				transform: scale(0.3) translateX(80%) translateY(-100%);
			}
		}
		.rubriks{
			display: none;
		}
		.rubriks-mobile{
			display: block;
			padding: 30px 8%;
			margin-top: 20px;
			h3{
				text-align: left;
				margin: 0;
				font-weight: 800;
				font-size: 20px;
				line-height: 20px;
				letter-spacing: 0.04em;
				color: #333333;
			}
			.rubs{
				width: 100%;
				flex-wrap: wrap;
				.list-item{
					background: #F6F4EB;
					border-radius: 10px;
					cursor: pointer;
					width: 280px;
					height: 220px;
					margin: 15px calc(25% - 140px); 	
					border-radius: 10px;
					position: relative;
					.img-list-item{
						margin: 10px auto 0 auto;
						border-radius: 50%;
						height: 168px;
						width: 168px;
					}
					span{
						text-overflow: ellipsis;
						overflow: hidden; 
						white-space: nowrap;
						position: absolute;
						bottom: 14px;
						left: 10px;
						font-weight: bold;
						font-size: 20px;
						line-height: 26px;
						color: #568357;
					}
				}
				.list-item:hover{
					box-shadow: 5px 20px 50px rgba(94, 115, 97, 0.35);
				}
			}
		}
		.news{
			height: 724px;
			margin-bottom: 50px;
			.content{
				padding: 40px 12% 155px 12%;
				h3{
					font-size: 28px;
					line-height: 28px;
				}
				.info{
					margin-top: 20px;
					overflow: hidden;
					.list{
						width: 30%;
						margin-top: 200px;
						.item{
							box-shadow: none !important;
							width: 100%;
							margin-bottom: 20px;
						}
					}
					.news-list{
						margin-left: 0;
						position: absolute;
						.item{
							cursor: pointer;
							position: relative;
							margin: 0 20px 0 0;
							height: 180px;
							width: 210px;
							background: url('/media/home/Rectangle16.png') center no-repeat;
							// box-shadow: 5px 20px 50px rgba(0, 0, 0, 0.2);
							border-radius: 10px;
							.text{
								width: 186px;
								position: absolute;
								bottom: 0;
								height: 60px;
								background: rgba(86, 105, 126, 0.7);
								backdrop-filter: blur(14px);
								border-radius: 0px 0px 10px 10px;
								padding: 6px 12px;
								h5, p{
									text-align: left;
									margin: 0;
								}
								h5{
									height: 16px;
									text-overflow: ellipsis;
									overflow: hidden; 
									white-space: nowrap;
									font-weight: bold;
									font-size: 16px;
									line-height: 20px;
									letter-spacing: 0.05em;
									color: #FFFFFF;
								}
								p{
									height: 35px;
									text-overflow: ellipsis;
									overflow: hidden; 
									white-space: nowrap;
									cursor: pointer;
									margin-top: 6px;
									font-weight: 500;
									font-size: 12px;
									line-height: 14px;
									letter-spacing: 0.05em;
									color: #FFFFFF;
								}
							}
						}
					}
				}
			}
		}
		.survey{
			height: 343px;
			padding: 20px 12%;
			h3{
				font-size: 28px;
				line-height: 49px;
			}
			.q-num{
				margin-top: 10px;
				font-size: 16px;
				line-height: 30px;
			}
			p{
				margin-top: 10px;
				font-size: 24px;
				line-height: 30px;
			}
			.options{
				.option{
					margin-top: 15px;
					label{
						margin-left: 15px;
						font-size: 16px;
						line-height: 22px;
					}
				}
			}
			.results{
				.option{
					margin-top: 15px;
					span{
						font-size: 18px;
						line-height: 26px;
					}
					label{
						margin-left: 15px;
						font-size: 18px;
						line-height: 26px;
					}
				}
			}
			.vote-total{
				bottom: 34px;
				left: 12%;
				font-size: 16px;
				line-height: 30px;
			}
			.next-btn {
				right: 12%;
				padding: 15px 44px;
			}
		}
		.survey-end{
			height: 168px;
			padding: 45px 0 100px 0;
			h3{
				margin-top: 28px;
				font-size: 32px;
				line-height: 49px;
			}
			p{
				margin-top: 15px;
				font-size: 22px;
				line-height: 30px;
			}
			img{
				width: 12%;
			}
		}
		.location{
			padding: 30px 8% 0 8%;
			h3{
				font-size: 28px;
				line-height: 38px;
			}
			p{
				font-size: 20px;
				line-height: 28px;
			}
			.local{
				width: 100%;
				height: 480px;
				margin-top: 30px;
				border-radius: 10px;
				flex-direction: column;
				.map{
					height: 240px;
					width: 100%;
					img{
						object-fit: contain;
					}
				}
				.info{
					width: calc(100% - 12px);
					padding: 8px 6px;
					flex-direction: row;
					.city{
						position: absolute;
						margin-bottom: 0px;
						margin-left: 10px;
					}
					.info-box{
						padding: 12px 10px;
						width: 245px;
						overflow: hidden;
						margin: 40px 4px;
					}
					.more-info{
						left: 20px;
					}
				}
			}
		}
		.partner{
			padding: 20px 12%;
			// height: 200px;
			h3{
				font-size: 28px;
				line-height: 38px;
			}
		}
	}
}
@media only screen and (max-width: 720px){
	.outer{
		.top-section{
			padding: 40px 6% 10px 6%;
			.top-head-text{
				h3{
					font-size: 32px;
					line-height: 38px;
				}
				span{
					font-size: 26px;
					line-height: 28px;
				}
			}
			.top-body-text{
				max-width: 100%;
				margin-top: 230px;
				font-size: 18px;
				line-height: 24px;
			}
			a{
				margin-top: 20px;
			}	
			.top-img{
				display: none;
			}
			.top-img-mobile{
				display: block;
				position: absolute;
				top: 60px;
				right: 2%;	
				z-index: 99;
				transform: scale(0.25) translateX(130%) translateY(-120%);
			}
		}
		.rubriks-mobile{
			display: block;
			padding: 30px 6%;
			margin-top: 20px;
			h3{
				text-align: left;
				margin: 0;
				font-weight: 800;
				font-size: 20px;
				line-height: 20px;
				letter-spacing: 0.04em;
				color: #333333;
			}
			.rubs{
				width: 100%;
				flex-wrap: wrap;
				.list-item{
					background: #F6F4EB;
					border-radius: 10px;
					cursor: pointer;
					width: 100%;
					height: 220px;
					margin: 15px 0;	
					border-radius: 10px;
					position: relative;
					.img-list-item{
						margin: 10px auto 0 auto;
						border-radius: 50%;
						height: 168px;
						width: 168px;
					}
					span{
						text-overflow: ellipsis;
						overflow: hidden; 
						white-space: nowrap;
						position: absolute;
						bottom: 14px;
						left: 10px;
						font-weight: bold;
						font-size: 20px;
						line-height: 26px;
						color: #568357;
					}
				}
				.list-item:hover{
					box-shadow: 5px 20px 50px rgba(94, 115, 97, 0.35);
				}
			}
		}
		.news{
			height: 724px;
			margin-bottom: 50px;
			.content{
				padding: 40px 6% 155px 6%;
				h3{
					font-size: 28px;
					line-height: 28px;
				}
				.info{
					margin-top: 20px;
					overflow: hidden;
					.list{
						width: 30%;
						margin-top: 200px;
						.item{
							box-shadow: none !important;
							width: 100%;
							margin-bottom: 20px;
						}
					}
					.news-list{
						margin-left: 0;
						position: absolute;
						.item{
							cursor: pointer;
							position: relative;
							margin: 0 20px 0 0;
							height: 180px;
							width: 210px;
							background: url('/media/home/Rectangle16.png') center no-repeat;
							// box-shadow: 5px 20px 50px rgba(0, 0, 0, 0.2);
							border-radius: 10px;
							.text{
								width: 186px;
								position: absolute;
								bottom: 0;
								height: 60px;
								background: rgba(86, 105, 126, 0.7);
								backdrop-filter: blur(14px);
								border-radius: 0px 0px 10px 10px;
								padding: 6px 12px;
								h5, p{
									text-align: left;
									margin: 0;
								}
								h5{
									height: 16px;
									text-overflow: ellipsis;
									overflow: hidden; 
									white-space: nowrap;
									font-weight: bold;
									font-size: 16px;
									line-height: 20px;
									letter-spacing: 0.05em;
									color: #FFFFFF;
								}
								p{
									height: 35px;
									text-overflow: ellipsis;
									overflow: hidden; 
									white-space: nowrap;
									cursor: pointer;
									margin-top: 6px;
									font-weight: 500;
									font-size: 12px;
									line-height: 14px;
									letter-spacing: 0.05em;
									color: #FFFFFF;
								}
							}
						}
					}
				}
			}
		}
		.survey{
			height: 373px;
			padding: 20px 12%;
			h3{
				font-size: 28px;
				line-height: 49px;
			}
			.q-num{
				margin-top: 10px;
				font-size: 16px;
				line-height: 30px;
			}
			p{
				margin-top: 10px;
				font-size: 24px;
				line-height: 30px;
			}
			.options{
				.option{
					margin-top: 15px;
					label{
						margin-left: 15px;
						font-size: 16px;
						line-height: 22px;
					}
				}
			}
			.results{
				.option{
					margin-top: 15px;
					span{
						font-size: 18px;
						line-height: 26px;
					}
					label{
						margin-left: 15px;
						font-size: 18px;
						line-height: 26px;
					}
				}
			}
			.vote-total{
				display: none;
				bottom: 34px;
				left: 12%;
				font-size: 16px;
				line-height: 30px;
			}
			.next-btn{
				margin-top: 10px;
				width: calc(88% - 88px);
				text-align: center;
				right: 6%;
				padding: 15px 44px;
			}
		}
		.survey-end{
			height: 168px;
			padding: 45px 0 100px 0;
			h3{
				margin-top: 28px;
				font-size: 32px;
				line-height: 49px;
			}
			p{
				margin-top: 15px;
				font-size: 22px;
				line-height: 30px;
			}
			img{
				width: 12%;
			}
		}
		.location{
			padding: 30px 8% 0 8%;
			overflow: hidden;
			h3{
				font-size: 28px;
				line-height: 38px;
			}
			p{
				font-size: 20px;
				line-height: 28px;
			}
			.local{
				width: 100%;
				height: 480px;
				margin-top: 30px;
				border-radius: 10px;
				flex-direction: column;
				overflow: hidden;
				.map{
					height: 240px;
					width: 100%;
					img{
						object-fit: contain;
					}
				}
				.info{
					width: calc(300%);
					padding: 8px 6px;
					flex-direction: row;
					overflow: hidden;
					.city{
						position: absolute;
						margin-bottom: 0px;
						margin-left: 10px;
					}
					.info-box{
						padding: 12px 10px;
						width: 185px;
						overflow: hidden;
						margin: 40px 4px;
					}
					.more-info{
						left: 20px;
					}
				}
			}
		}
		.partner{
			padding: 20px 6%;
			height: 160px;
			overflow: hidden;
			h3{
				font-size: 28px;
				line-height: 38px;
			}
		}
	}
}
@media only screen and (max-width: 480px){
	.outer{
		.top-section{
			padding: 40px 4% 10px 4%;
			.top-head-text{
				h3{
					font-weight: 800;
					font-size: 26px;
					line-height: 38px;
				}
				span{
					margin-top: 5px;
					font-weight: 800;
					font-size: 16px;
					line-height: 28px;
				}
			}
			.top-body-text{
				max-width: 100%;
				margin-top: 180px;
				font-size: 16px;
				line-height: 20px;
			}
			a{
				width: 92%;
				margin-top: 15px;
			}	
			.top-img{
				display: none;
			}
			.top-img-mobile{
				display: block;
				position: absolute;
				top: 60px;
				right: 2%;	
				z-index: 99;
				transform: scale(0.22) translateX(160%) translateY(-160%);
			}
		}
		.rubriks-mobile{
			display: block;
			padding: 20px 4%;
			margin-top: 10px;
			h3{
				text-align: left;
				margin: 0;
				font-weight: 800;
				font-size: 26px;
				line-height: 28px;
				letter-spacing: 0.04em;
				color: #333333;
			}
			.rubs{
				margin-top: 10px;
				width: 100%;
				flex-wrap: wrap;
				.list-item{
					background: #F6F4EB;
					border-radius: 10px;
					cursor: pointer;
					width: 100%;
					height: 220px;
					margin: 8px 0;	
					border-radius: 10px;
					position: relative;
					.img-list-item{
						margin: 10px auto 0 auto;
						border-radius: 50%;
						height: 168px;
						width: 168px;
					}
					span{
						text-overflow: ellipsis;
						overflow: hidden; 
						white-space: nowrap;
						position: absolute;
						bottom: 10px;
						left: 10px;
						font-weight: bold;
						font-size: 18px;
						line-height: 26px;
						color: #568357;
					}
				}
				.list-item:hover{
					box-shadow: 5px 20px 50px rgba(94, 115, 97, 0.35);
				}
			}
		}
		.news{
			height: 674px;
			margin-bottom: 30px;
			.content{
				padding: 20px 4% 40px 4%;
				h3{
					font-size: 26px;
					line-height: 28px;
				}
				.info{
					margin-top: 30px;
					overflow: hidden;
					.list{
						width: 30%;
						margin-top: 200px;
						.item{
							box-shadow: none !important;
							width: 100%;
							margin-bottom: 20px;
							padding: 8px 15px 8px 10px;
							.top{
								.date{
									font-size: 14px;
								}
								.link{
									font-size: 14px;
								}
							}
							.text{
								font-size: 14px;
							}
						}
					}
					.news-list{
						margin-left: 0;
						position: absolute;
						.item{
							cursor: pointer;
							position: relative;
							margin: 0 20px 0 0;
							height: 180px;
							width: 210px;
							background: url('/media/home/Rectangle16.png') center no-repeat;
							// box-shadow: 5px 20px 50px rgba(0, 0, 0, 0.2);
							border-radius: 10px;
							.text{
								width: 186px;
								position: absolute;
								bottom: 0;
								height: 60px;
								background: rgba(86, 105, 126, 0.7);
								backdrop-filter: blur(14px);
								border-radius: 0px 0px 10px 10px;
								padding: 6px 12px;
								h5, p{
									text-align: left;
									margin: 0;
								}
								h5{
									height: 16px;
									text-overflow: ellipsis;
									overflow: hidden; 
									white-space: nowrap;
									font-weight: bold;
									font-size: 16px;
									line-height: 20px;
									letter-spacing: 0.05em;
									color: #FFFFFF;
								}
								p{
									height: 35px;
									text-overflow: ellipsis;
									overflow: hidden; 
									white-space: nowrap;
									cursor: pointer;
									margin-top: 6px;
									font-weight: 500;
									font-size: 12px;
									line-height: 14px;
									letter-spacing: 0.05em;
									color: #FFFFFF;
								}
							}
						}
					}
				}
			}
		}
		.survey{
			height: 310px;
			padding: 20px 4%;
			h3{
				font-size: 26px;
				line-height: 28px;
			}
			.q-num{
				margin-top: 10px;
				font-size: 16px;
				line-height: 30px;
			}
			p{
				margin-top: 10px;
				font-size: 16px;
				line-height: 30px;
			}
			.options{
				.option{
					margin-top: 15px;
					label{
						margin-left: 15px;
						font-size: 14px;
						line-height: 22px;
					}
				}
			}
			.results{
				.option{
					margin-top: 15px;
					span{
						font-size: 16px;
						line-height: 26px;
					}
					label{
						margin-left: 15px;
						font-size: 16px;
						line-height: 26px;
					}
				}
			}
			.next-btn{
				margin-top: 10px;
				width: calc(92% - 88px);
				text-align: center;
				right: 4%;
				padding: 8px 44px;
				span{
					cursor: pointer;
					font-weight: 500;
					font-size: 14px;
					line-height: 26px;
					letter-spacing: 0.04em;
					color: #FFFFFF;
				}
			}
		}
		.survey-end{
			height: 148px;
			padding: 25px 0 60px 0;
			h3{
				margin-top: 10px;
				font-size: 26px;
				line-height: 49px;
			}
			p{
				margin-top: 10px;
				font-size: 18px;
				line-height: 30px;
			}
			img{
				width: 18%;
			}
		}
		.location{
			padding: 20px 8% 0 8%;
			overflow: hidden;
			h3{
				font-size: 26px;
				line-height: 28px;
			}
			p{
				font-size: 16px;
				line-height: 20px;
			}
			.local{
				width: 100%;
				height: 480px;
				margin-top: 30px;
				border-radius: 10px;
				flex-direction: column;
				overflow: hidden;
				.map{
					height: 240px;
					width: 100%;
					img{
						object-fit: contain;
					}
				}
				.info{
					width: calc(300%);
					padding: 8px 6px;
					flex-direction: row;
					overflow: hidden;
					.city{
						position: absolute;
						margin-bottom: 0px;
						margin-left: 10px;
						font-size: 14px;
					}
					.info-box{
						padding: 12px 10px;
						width: 185px;
						overflow: hidden;
						margin: 40px 4px;
						h5{
							font-size: 14px;
						}
						div{
							span{
								font-size: 12px;
							}
						}
					}
					.more-info{
						left: 20px;
					}
				}
			}
		}
		.partner{
			padding: 20px 6%;
			height: 180px;
			overflow: hidden;
			h3{
				font-size: 28px;
				line-height: 38px;
			}
		}
	}
}
@media only screen and (max-width: 480px){
	.outer{
		.top-section{
			padding: 40px 4% 10px 4%;
			.top-head-text{
				h3{
					font-weight: 800;
					font-size: 26px;
					line-height: 38px;
				}
				span{
					font-weight: 800;
					font-size: 16px;
					line-height: 28px;
				}
			}
			.top-body-text{
				max-width: 100%;
				margin-top: 180px;
				font-size: 16px;
				line-height: 20px;
			}
			a{
				width: 92%;
				margin-top: 15px;
			}	
			.top-img{
				display: none;
			}
			.top-img-mobile{
				display: block;
				position: absolute;
				top: 60px;
				right: 2%;	
				z-index: 99;
				transform: scale(0.22) translateX(170%) translateY(-160%);
			}
		}
		.partner{
			padding: 20px 12%;
			height: 140px;
			// overflow: hidden;
			h3{
				font-size: 28px;
				line-height: 38px;
			}
			.no-shadow{
				width: 100%;
				height: 161px;
			}
		}
	}
}
</style>
